import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TransactionService } from 'src/app/services/transaction.service';
import { Transaction } from 'src/app/entities/transaction';
import { AlertService } from 'src/app/services/alert.service';
import { Office, Delivery } from 'src/app/entities/office';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent implements OnInit {

  @Output() clickContinue = new EventEmitter<any>();

  transaction: Transaction;
  offices = new Array<Office>();
  delivery = new Array<Delivery>();

  selectedOffice;

  deliveryName = '';
  deliveryAddress = '';
  deliveryNumber = '';
  deliveryFloor = '';
  deliveryCode = '';

  // OCA Shipping properties
  ocaZipCode = '';
  ocaName = '';
  ocaStreet = '';
  ocaNumber = '';
  ocaFloor = '';
  ocaPhone = '';
  ocaShippingResult: any = null;
  ocaShippingError = '';
  isCalculatingOcaShipping = false;

  constructor(
    protected alertService: AlertService,
    protected transactionService: TransactionService,
    protected cartService: CartService
  ) {
    this.transaction = transactionService.transactionCurrent;
  }

  ngOnInit() {
    this.loadOffices();
    // Initialize Feather icons
    setTimeout(() => {
      if (typeof (window as any).feather !== 'undefined') {
        (window as any).feather.replace();
      }
    }, 0);
  }

  onClickContinue() {
    // Validate that a delivery option has been selected
    if(this.step === 0) {
      this.alertService.showError('Error!', 'Debe seleccionar una opción de entrega para continuar.');
      return;
    }

    if(this.step == 2 && (this.deliveryName == '' || this.deliveryAddress == '' || this.deliveryNumber == '' || this.deliveryNumber == '')){
      this.alertService.showError('Error!', 'Todos los campos son obligatorios.');
      return;
    }
    if(this.step == 3 && (this.ocaName == '' || this.ocaStreet == '' || this.ocaNumber == '' || this.ocaPhone == '' || this.ocaZipCode == '')){
      this.alertService.showError('Error!', 'Debe completar todos los campos obligatorios para envío con OCA.');
      return;
    }
    if(this.step == 3 && this.ocaShippingResult == null){
      this.alertService.showError('Error!', 'Debe calcular el costo de envío antes de continuar.');
      return;
    }
    if(this.step == 1){
      if(this.getOfficeSelected() == null || this.getOfficeSelected() == undefined){
        this.alertService.showError('Error!', 'Debe seleccionar una sucursal para retirar su compra.');
        return;
      }
    }

    this.processDelivery();
    this.clickContinue.emit();
  }

  onChangeOffice(data) {
    let officeId = data.source.value.id;
    for (const office of this.offices) {
      if (office.id != officeId) {
        office.is_selected = false;
      }
    }
  }

  getOfficeSelected() {
    for (const office of this.offices) {
      if (office.is_selected) {
        return office;
      }
    }
  }

  loadOffices() {
    this.transactionService.offices().toPromise().then(data => {
      if (!data.success) {
        return;
      }
      this.offices = data.response.offices;
      this.delivery = data.response.delivery;
    });
  }

  getDeliveryPrice(): string {
    for (const delivery of this.delivery) {
      let min = parseFloat(delivery.min_amount);
      let max = parseFloat(delivery.max_amount);
      let total = parseFloat(this.transaction.total);
      if (min < total && max >= total && delivery.status == 1) {
        return delivery.price;
      }
    }
    return 'Calcular costo';
  }

  step = 0;

  setStep(index: number) {
    // Simply set the step - this will close others and open the selected one
    this.step = index;
    
    this.cleanDelivery();
    this.processDelivery();
    // Initialize Feather icons when step changes
    setTimeout(() => {
      if (typeof (window as any).feather !== 'undefined') {
        (window as any).feather.replace();
      }
    }, 0);
  }

  toggleStep(index: number, event: Event) {
    event.stopPropagation(); // Prevent card click
    // Toggle: if it's the active one, close it. Otherwise, open it
    if (this.step === index) {
      this.step = 0;
    } else {
      this.step = index;
    }
    this.cleanDelivery();
    this.processDelivery();
    // Initialize Feather icons
    setTimeout(() => {
      if (typeof (window as any).feather !== 'undefined') {
        (window as any).feather.replace();
      }
    }, 0);
  }

  closeExpansionPanel() {
    this.step = 0;
  }

  calculateOcaShipping() {
    // Validate zip code
    if (!this.ocaZipCode || this.ocaZipCode.trim().length < 4) {
      this.ocaShippingError = 'Por favor ingrese un código postal válido';
      this.ocaShippingResult = null;
      return;
    }

    this.isCalculatingOcaShipping = true;
    this.ocaShippingError = '';
    this.ocaShippingResult = null;

    // Get fingerprint from CartService
    const fingerprint = this.cartService.fingerprintCurrent;

    this.transactionService.calculateOcaShipping(fingerprint, this.ocaZipCode)
      .toPromise()
      .then(response => {
        this.isCalculatingOcaShipping = false;
        if (response.success && response.response) {
          this.ocaShippingResult = response.response;
        } else {
          // Use backend error message if available, otherwise fallback to generic message
          if (response.error && response.error.message) {
            this.ocaShippingError = response.error.message;
          } else {
            this.ocaShippingError = 'No se pudo calcular el envío. Verifique el código postal o algunos productos pueden no tener las medidas cargadas. Si el error persiste seleccione otro método de envío.';
          }
        }
        // Initialize Feather icons after showing result
        setTimeout(() => {
          if (typeof (window as any).feather !== 'undefined') {
            (window as any).feather.replace();
          }
        }, 0);
      })
      .catch(error => {
        this.isCalculatingOcaShipping = false;
        this.ocaShippingError = 'Error al calcular el envío. Por favor intente nuevamente.';
        // Initialize Feather icons after showing error
        setTimeout(() => {
          if (typeof (window as any).feather !== 'undefined') {
            (window as any).feather.replace();
          }
        }, 0);
      });
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  cleanDelivery() {
    if (this.transactionService.transactionCurrent.data_payment == undefined) {
      this.transactionService.transactionCurrent.data_payment = {};
    }

    this.transactionService.transactionCurrent.data_payment.delivery = undefined;
    this.transactionService.transactionCurrent.data_payment.office = undefined;
  }

  processDelivery() {


    if(this.step == 1){
      this.transactionService.transactionCurrent.data_payment.office = this.getOfficeSelected();
      this.transactionService.currentDelivery.next(null);
    }else if (this.step == 2) {
      let current: any = null;
      for (const delivery of this.delivery) {
        let min = parseFloat(delivery.min_amount);
        let max = parseFloat(delivery.max_amount);
        let total = parseFloat(this.transaction.total);
        if (delivery.status === 1 && min < total && max >= total) {
          current = delivery;
          break;
        }
      }

      if (current) {
        this.transactionService.currentDelivery.next(current);
        this.transactionService.transactionCurrent.data_payment.delivery = current;
        this.transactionService.transactionCurrent.data_payment.delivery.name = this.deliveryName;
        this.transactionService.transactionCurrent.data_payment.delivery.number = this.deliveryNumber;
        this.transactionService.transactionCurrent.data_payment.delivery.address = this.deliveryAddress;
        this.transactionService.transactionCurrent.data_payment.delivery.phone = this.deliveryCode;
      } else {
        this.transactionService.currentDelivery.next(null);
      }
    } else if (this.step == 3) {
      // OCA Shipping
      const ocaDelivery = {
        delivery_type: 2,
        name: this.ocaName,
        street: this.ocaStreet,
        number: this.ocaNumber,
        floor: this.ocaFloor,
        phone: this.ocaPhone,
        zip_code: this.ocaZipCode,
        shipping_cost: this.ocaShippingResult ? this.ocaShippingResult.total : 0,
        delivery_days: this.ocaShippingResult ? this.ocaShippingResult.plazo_entrega : '',
        price: 0 // OCA shipping is paid separately on delivery
      };
      this.transactionService.transactionCurrent.data_payment.delivery = ocaDelivery;
      this.transactionService.currentDelivery.next(ocaDelivery as any);
    } else {
      this.transactionService.currentDelivery.next(null);
    }
  }
}
